class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.desktopQuery = window.matchMedia('(min-width: 990px)');
    this.closeTimeout = null;

    HeaderMenu.injectHoverStyles();

    this.addEventListener('mouseenter', this.openOnHover.bind(this));
    this.addEventListener('mouseleave', this.closeOnHover.bind(this));
    this.addEventListener('focusin', this.openOnFocus.bind(this));
    this.querySelector('summary').addEventListener('click', this.onSummaryClick.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  static injectHoverStyles() {
    if (document.getElementById('header-hover-menu-styles')) return;

    const style = document.createElement('style');
    style.id = 'header-hover-menu-styles';
    style.textContent = `
      @media screen and (min-width: 990px) {
        .header__inline-menu header-menu > details > summary {
          cursor: default;
        }

        .header__inline-menu header-menu > details > .header__submenu {
          border: 0;
          border-radius: 0;
          box-shadow: 0 1.8rem 4rem rgba(var(--color-shadow), 0.08);
          margin-top: 0;
          min-width: 22rem;
          padding: 1.2rem 0;
          pointer-events: none;
          transition: opacity 180ms ease, transform 180ms ease, visibility 180ms ease;
          visibility: hidden;
        }

        .header__inline-menu header-menu > details[open] > .header__submenu {
          animation: none;
          opacity: 1;
          pointer-events: auto;
          transform: translateY(0);
          visibility: visible;
        }

        .header__inline-menu .header__submenu .header__menu-item {
          font-size: 1.2rem;
          letter-spacing: 0.04em;
          padding: 0.75rem 2.4rem;
          text-decoration: none;
        }

        .header__inline-menu .header__submenu .header__menu-item:hover,
        .header__inline-menu .header__submenu .header__menu-item:hover span {
          text-decoration: none;
        }
      }
    `;
    document.head.appendChild(style);
  }

  isDesktopHoverEnabled() {
    return this.desktopQuery.matches;
  }

  openOnHover() {
    if (!this.isDesktopHoverEnabled()) return;
    this.open();
  }

  closeOnHover() {
    if (!this.isDesktopHoverEnabled()) return;
    this.queueClose();
  }

  openOnFocus() {
    if (!this.isDesktopHoverEnabled()) return;
    this.open();
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.contains(document.activeElement)) return;
      this.isDesktopHoverEnabled() ? this.queueClose() : this.close();
    });
  }

  onSummaryClick(event) {
    if (!this.isDesktopHoverEnabled()) return;

    event.preventDefault();
    this.open();
  }

  open() {
    window.clearTimeout(this.closeTimeout);
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  queueClose() {
    window.clearTimeout(this.closeTimeout);
    this.closeTimeout = window.setTimeout(() => {
      if (this.matches(':hover') || this.contains(document.activeElement)) return;
      this.close();
    }, 140);
  }

  close() {
    window.clearTimeout(this.closeTimeout);
    super.close();
  }
}

customElements.define('header-menu', HeaderMenu);
